<div
  class="relative w-full max-w-[580px] h-[480px] flex items-center justify-center perspective-1000 select-none"
>
  <div
    #hologramContainer
    class="relative w-full h-full flex items-center justify-center transform-style-3d"
  >
    <!-- Background Energy Halo & Cosmic Rings -->
    <div
      class="absolute w-[380px] h-[380px] rounded-full bg-radial from-pink-600/30 via-primary/20 to-transparent blur-3xl pointer-events-none"
    ></div>
    <div
      class="absolute w-[330px] h-[330px] rounded-full border border-primary/25 border-dashed animate-spin-slow pointer-events-none"
    ></div>
    <div
      class="absolute w-[420px] h-[420px] rounded-full border border-pink-500/20 animate-reverse-spin pointer-events-none"
    ></div>

    <!-- Central 3D Angular Logo (Faceted Crystal Shield) -->
    <div
      #centerGem
      class="relative z-20 flex flex-col items-center justify-center transform-style-3d cursor-pointer group"
    >
      <div
        class="absolute -inset-8 rounded-full bg-radial from-pink-500/35 via-primary/25 to-transparent opacity-70 blur-3xl group-hover:opacity-90 transition duration-700 pointer-events-none"
      ></div>

      <svg
        class="relative w-36 h-36 sm:w-44 sm:h-44 xl:w-48 xl:h-48 drop-shadow-[0_0_40px_rgba(255,49,216,0.45)] transform-style-3d group-hover:scale-105 transition-transform duration-500 z-10 select-none"
        viewBox="0 0 250 250"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <!-- Official Angular Gradients with 3D Vibrancy -->
          <linearGradient
            id="hologramAngLeftGrad"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#FF31D8" />
            <stop offset="100%" stop-color="#FF1493" />
          </linearGradient>

          <linearGradient
            id="hologramAngRightGrad"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#E335FF" />
            <stop offset="100%" stop-color="#6657EC" />
          </linearGradient>

          <linearGradient
            id="hologramAngCenterGrad"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#FF31D8" />
            <stop offset="100%" stop-color="#E335FF" />
          </linearGradient>

          <linearGradient
            id="hologramAngBottomGrad"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#FF1493" />
            <stop offset="100%" stop-color="#C00865" />
          </linearGradient>

          <!-- Crystal Wireframe / Edge Highlight Gradient -->
          <linearGradient
            id="hologramCrystalWireframe"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.95" />
            <stop offset="50%" stop-color="#FF31D8" stop-opacity="0.75" />
            <stop offset="100%" stop-color="#6657EC" stop-opacity="0.85" />
          </linearGradient>
        </defs>

        <!-- Left Wing Base & 3D Crystal Facets -->
        <path
          d="M 101 28 L 34 58 L 45 162 Z"
          fill="url(#hologramAngLeftGrad)"
        />
        <path d="M 101 28 L 34 58 L 65 80 Z" fill="#FFFFFF" opacity="0.32" />
        <path d="M 34 58 L 45 162 L 65 80 Z" fill="#000000" opacity="0.22" />

        <!-- Right Wing Base & 3D Crystal Facets -->
        <path
          d="M 149 28 L 216 58 L 205 162 Z"
          fill="url(#hologramAngRightGrad)"
        />
        <path d="M 149 28 L 216 58 L 185 80 Z" fill="#FFFFFF" opacity="0.32" />
        <path d="M 216 58 L 205 162 L 185 80 Z" fill="#000000" opacity="0.25" />

        <!-- Center Triangle Base & 3D Crystal Facets -->
        <path
          d="M 125 76 L 153 143 L 97 143 Z"
          fill="url(#hologramAngCenterGrad)"
        />
        <path d="M 125 76 L 97 143 L 125 115 Z" fill="#FFFFFF" opacity="0.28" />
        <path
          d="M 97 143 L 153 143 L 125 115 Z"
          fill="#000000"
          opacity="0.20"
        />

        <!-- Bottom Hexagon Base & 3D Crystal Facets -->
        <path
          d="M 87 166 L 163 166 L 175 196 L 125 224 L 75 196 Z"
          fill="url(#hologramAngBottomGrad)"
        />
        <path
          d="M 87 166 L 163 166 L 125 185 Z"
          fill="#FFFFFF"
          opacity="0.26"
        />
        <path
          d="M 125 224 L 75 196 L 125 185 Z"
          fill="#000000"
          opacity="0.30"
        />
        <path
          d="M 175 196 L 125 224 L 125 185 Z"
          fill="#000000"
          opacity="0.18"
        />
        <path d="M 75 196 L 87 166 L 125 185 Z" fill="#FFFFFF" opacity="0.12" />

        <!-- Crystal Edges / Glowing Facet Seams -->
        <g
          stroke="url(#hologramCrystalWireframe)"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
          opacity="0.65"
          fill="none"
        >
          <path d="M 101 28 L 65 80 L 34 58 M 65 80 L 45 162" />
          <path d="M 101 28 L 34 58 L 45 162 Z" />
          <path d="M 149 28 L 185 80 L 216 58 M 185 80 L 205 162" />
          <path d="M 149 28 L 216 58 L 205 162 Z" />
          <path d="M 125 76 L 125 115 L 97 143 M 125 115 L 153 143" />
          <path d="M 125 76 L 153 143 L 97 143 Z" />
          <path
            d="M 87 166 L 125 185 L 163 166 M 75 196 L 125 185 L 175 196 M 125 224 L 125 185"
          />
          <path d="M 87 166 L 163 166 L 175 196 L 125 224 L 75 196 Z" />
        </g>
      </svg>
    </div>

    <!-- Orbiting Satellites System -->
    <div
      #orbitSystem
      class="absolute inset-0 pointer-events-none transform-style-3d"
    >
      <!-- Sat 1: Testes Automatizados -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-pink-500/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(236,72,153,0.25)] hover:bg-[#161E2E]/95 hover:border-pink-400 hover:shadow-[0_0_25px_rgba(236,72,153,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-pink-500/20 border border-pink-500/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(236,72,153,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-shield-check text-pink-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >Testes Automatizados</span
          >
        </div>
      </div>

      <!-- Sat 2: Arquitetura Enterprise -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-purple-500/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(168,85,247,0.25)] hover:bg-[#161E2E]/95 hover:border-purple-400 hover:shadow-[0_0_25px_rgba(168,85,247,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-purple-500/20 border border-purple-500/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(168,85,247,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-diagram-3-fill text-purple-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >Arquitetura Enterprise</span
          >
        </div>
      </div>

      <!-- Sat 3: Nx Workspace -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-cyan-400/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(6,182,212,0.25)] hover:bg-[#161E2E]/95 hover:border-cyan-300 hover:shadow-[0_0_25px_rgba(6,182,212,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-cyan-400/20 border border-cyan-400/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(6,182,212,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-boxes text-cyan-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >Nx Workspace</span
          >
        </div>
      </div>

      <!-- Sat 4: IA para Devs -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-amber-400/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(245,158,11,0.25)] hover:bg-[#161E2E]/95 hover:border-amber-300 hover:shadow-[0_0_25px_rgba(245,158,11,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-amber-400/20 border border-amber-400/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-cpu-fill text-amber-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >IA para Devs</span
          >
        </div>
      </div>

      <!-- Sat 5: Signals & RxJS -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-rose-500/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(244,63,94,0.25)] hover:bg-[#161E2E]/95 hover:border-rose-400 hover:shadow-[0_0_25px_rgba(244,63,94,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-rose-500/20 border border-rose-500/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(244,63,94,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-lightning-charge-fill text-rose-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >Signals & RxJS</span
          >
        </div>
      </div>

      <!-- Sat 6: Mentoria Especializada -->
      <div
        #satellite
        class="absolute left-1/2 top-1/2 pointer-events-auto cursor-pointer"
        (mouseenter)="pauseOrbit()"
        (mouseleave)="resumeOrbit()"
      >
        <div
          class="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-[#0B0F17]/90 border border-emerald-500/40 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(16,185,129,0.25)] hover:bg-[#161E2E]/95 hover:border-emerald-400 hover:shadow-[0_0_25px_rgba(16,185,129,0.5)] transition-all duration-300 group"
        >
          <div
            class="w-7 h-7 rounded-full bg-emerald-500/20 border border-emerald-500/50 flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(16,185,129,0.4)] group-hover:scale-110 transition-transform"
          >
            <i class="bi bi-people-fill text-emerald-400 text-xs"></i>
          </div>
          <span
            class="whitespace-nowrap text-xs font-bold text-white tracking-wide"
            >Mentoria Especializada</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
